import {createNamespacedHelpers} from "vuex";
import drawChart from './draw-chart';
import {bootstrapDangerGrowl as errorGrowl} from "@core/Util/growler";

const {mapState, mapActions} = createNamespacedHelpers('audienceManager/charts');

import LoadingBox from "@core/Components/Util/LoadingBox";


export default {
    name: "CircleChart",
    components: {
        LoadingBox
    },
    mounted(){
        this.drawNewChart();
    },
    methods: Object.assign({
        drawNewChart(){
            this.loadCircleChartData(this.audienceId)
                .then(
                    () => {}, //Success case is taken care of in our watcher
                    err => errorGrowl(err)
                );
        }
    }, mapActions(['loadCircleChartData'])),
    watch: {
        circleChartRootNode(rootNode){
            if(!rootNode){
                return;
            }

            //It is not our duty to modify store state
            //we can however still create a local copy and modify that
            rootNode = JSON.parse(JSON.stringify(rootNode));
            
            //Our chartElement won't be available on the current render cycle yet
            this.$nextTick(() => {
                drawChart(
                    this.$refs['chart-element'],
                    rootNode,
                    this.chartOptions
                ); 
            });
        }
    },
    computed: {
        ...mapState(['circleChartRootNode']),
        canRenderChart(){
            return this.circleChartRootNode !== undefined;
        },
        /**
         * @returns {CircleChartOptions}
         */
        chartOptions(){
            return {
                backgroundColor: this.backgroundColor
            };
        }
    },
    props: {
        audienceId: {
            type: String,
            required: true
        },
        backgroundColor: {
            type: String,
            required: false
        }
    }
}